import _ from "lodash";
import {
  checkStatus,
  parseJSON,
  getPhpApiUrl,
  getHeaderForAjax,
} from "./ServiceHelper";
import { getLoggedInUser, getAccessToken } from "./AuthenticationService";

function getHeaderForFile() {
  return new Headers({
    // "Content-Type": "multipart/form-data",
    token: getAccessToken(),
    user: getLoggedInUser()._id,
  });
}
// function getApiUrl() {
//   return "https://api-php-dev.12u12.com/api/";
//   // return "http://127.0.0.1:8001/api/";
// }
export async function restaurantCont(data) {
  let name = data.name;
  let menu = data.menu;
  const formData = new FormData();
  formData.append("name", name);
  formData.append("length", menu.length);
  for (let i = 0; i < menu.length; i++) {
    // formData.append("menu[]", menu[i]);
    formData.append(`menu${i}`, menu[i]);
  }

  let user = await getLoggedInUser();
  let url = getPhpApiUrl() + "/contribute/" + user._id + "/restaurant";
  let method = "POST";
  return fetch(url, {
    method: method,
    headers: await getHeaderForFile(),
    body: formData,
  })
    .then(checkStatus)
    .then(parseJSON);
}
export async function barcode(file, cat) {
  const formData = new FormData();
  formData.append("image", file);

  let url = getPhpApiUrl() + "/contribute/barcodereader";
  let method = "POST";
  return fetch(url, {
    method: method,
    headers: await getHeaderForFile(),
    body: formData,
  })
    .then(checkStatus)
    .then(parseJSON);
}
// export async function sendImage(file, part, barcode) {
//   const formData = new FormData();
//   formData.append("image", file);
//   formData.append("part", part);
//   formData.append("barcode", barcode);
//   let url = getPhpApiUrl() + "/contribute/gettext";
//   let method = "POST";
//   return fetch(url, {
//     method: method,
//     headers: await getHeaderForFile(),
//     body: formData,
//   })
//     .then(checkStatus)
//     .then(parseJSON);
// }

export async function sendImage(file, part, barcode) {
  try {
    const formData = new FormData();
    formData.append("image", file);
    formData.append("part", part);
    formData.append("barcode", barcode);

    const url = getPhpApiUrl() + "/contribute/gettext";
    const method = "POST";
    const headers = await getHeaderForFile();

    const response = await fetch(url, {
      method: method,
      headers: headers,
      body: formData,
    });


    await checkStatus(response);  // This will throw an error if response is not OK
    const data = await parseJSON(response);

    return data;
  } catch (error) {
    // Check if error is an object and contains 'error' field
    const errorMessage = error && error.error ? error.error : 'An unknown error occurred';
    console.error("Error in sendImage function:", errorMessage);

    // Re-throw the error to be handled by the caller
    throw new Error(errorMessage);
  }
}

export async function submitData(data, barcode, category) {
  let user = await getLoggedInUser();
  let body = {
    data,
    barcode,
    category,
  };
  let url = getPhpApiUrl() + "/contribute/" + user._id + "/submit";
  let method = "POST";
  return fetch(url, {
    method: method,
    headers: await getHeaderForAjax(),
    body: JSON.stringify(body),
  })
    .then(checkStatus)
    .then(parseJSON);
}
export async function getBarcode(file) {
  const formData = new FormData();
  formData.append("image", file);

  let url = getPhpApiUrl() + "/contribute/getbarcode";
  let method = "POST";
  return fetch(url, {
    method: method,
    headers: await getHeaderForFile(),
    body: formData,
  })
    .then(checkStatus)
    .then(parseJSON);
}
// export function sendImage2(file) {
//   const formData = new FormData();

//   formData.append("image", file);

//   let url = getPhpApiUrl() + "/ocr/local";
//   let method = "POST";
//   return fetch(url, {
//     method: method,
//     // headers: getHeaderForAjax(),
//     body: formData,
//   })
//     .then(checkStatus)
//     .then(parseJSON);
// }



// WEBPACK FOOTER //
// ./src/services/ContributeService.js